import TradePage from "./TradePage";
import { trades } from "@/data/trades";

export default function Contractors() {
  return <TradePage trade={trades.contractors} />;
}
